import React, { useState } from "react";

export default function FilterBar({
  search,
  onSearch,
  riskFilter = "all",
  onRiskFilter,
  sortBy = "default",
  onSortBy,
  tag = "all",
  onTag,
  tagOptions = []
}) {
  const [openFilter, setOpenFilter] = useState(null); // 'risk', 'sort', 'tag' or null

  const riskOptions = ["Low Risk", "Medium Risk", "High Risk", "Very High Risk"];

  const sortOptions = [
    { value: "default", label: "Default" },
    { value: "relevance", label: "Relevance" },
    { value: "alphabetical", label: "Alphabetical" },
    { value: "status", label: "Status" },
    { value: "lastUpdated", label: "Last Modified" }
  ];

  return (
    <div className="mb-4 text-sm filter-bar">
      {/* Search Input */}
      <div style={{ marginBottom: 12 }} className="search-row">
        <div className="relative search-wrapper">
          <input
            className="w-full py-2 pl-2 pr-8 border rounded border-grey-200"
            type="text"
            placeholder="Filter results by keyword..."
            value={search}
            onChange={(e) => onSearch(e.target.value)}
          />
          {search && (
            <button
              className="absolute px-2 py-1 hover--opacity-80 text-white rounded clear-btn right-1 top-[5px] bg-ubc-blue"
              onClick={() => onSearch("")}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      {/* Filter Groups */}
      <div className="groups sm--grid sm--gap-x-6 sm--grid-cols-3">

        {/* Risk Filter */}
        <div className="relative group">
          <button
            className="w-full py-2 pl-2 pr-8 leading-none text-left bg-white border rounded group-title border-grey-200"
            onClick={() => setOpenFilter(openFilter === 'risk' ? null : 'risk')}
          >
            {riskFilter !== "all" ? `Filter by ${riskFilter}` : "Filter by..."}
          </button>
          <div className={`bg-white shadow btn-group absolute z-10 mt-1 w-full ${openFilter === 'risk' ? '' : 'hidden'}`}>
            <label
              key="all"
              data-risk="all"
              className={`btn block py-1 px-5 font-normal border-b border-light-blue hover--text-white hover--bg-ubc-blue ${riskFilter === 'all' ? "active" : ""}`}
            >
              <input
                type="radio"
                value="all"
                checked={riskFilter === 'all'}
                onChange={() => { onRiskFilter('all'); setOpenFilter(null); }}
                className="sr-only"
              />
              All Risks
            </label>
            {riskOptions.map(risk => (
              <label
                key={risk}
                data-risk={risk.toLowerCase().replace(/\s+/g, '-')}
                className={`btn block relative py-1 px-5 font-normal border-b hover--text-white hover--bg-ubc-blue border-light-blue before--absolute before--content-[''] before--block before--w-[10px] before--h-full before--top-0 before--left-0 ${riskFilter === risk ? "active" : ""}`}
              >
                <input
                  type="radio"
                  value={risk}
                  checked={riskFilter === risk}
                  onChange={() => { onRiskFilter(risk); setOpenFilter(null); }}
                  className="sr-only"
                />
                {risk}
              </label>
            ))}
          </div>
        </div>

        {/* Sort Filter */}
        <div className="relative group">
          <button
            className="w-full py-2 pl-2 pr-8 leading-none text-left bg-white border rounded group-title border-grey-200"
            onClick={() => setOpenFilter(openFilter === 'sort' ? null : 'sort')}
          >
            {sortBy && sortBy !== "default" ? `Sort by ${sortOptions.find(o => o.value === sortBy)?.label}` : "Sort by..."}
          </button>
          <div className={`bg-white shadow btn-group absolute z-10 mt-1 w-full ${openFilter === 'sort' ? '' : 'hidden'}`}>
            {sortOptions.map(opt => (
              <label
                key={opt.value}
                data-sort={opt.value}
                className={`btn block py-1 px-5 font-normal border-b border-light-blue hover--text-white hover--bg-ubc-blue ${sortBy === opt.value ? "active" : ""}`}
              >
                <input
                  type="radio"
                  value={opt.value}
                  checked={sortBy === opt.value}
                  onChange={() => { onSortBy(opt.value); setOpenFilter(null); }}
                  className="sr-only"
                />
                {opt.label}
              </label>
            ))}
          </div>
        </div>

        {/* Tag Filter */}
        <div className="relative group">
          <button
            className="w-full py-2 pl-2 pr-8 leading-none text-left bg-white border rounded group-title border-grey-200"
            onClick={() => setOpenFilter(openFilter === 'tag' ? null : 'tag')}
          >
            {tag !== "all" ? `Tag: ${tag}` : "Filter Tag..."}
          </button>
          <div className={`bg-white shadow btn-group absolute z-10 mt-1 w-full ${openFilter === 'tag' ? '' : 'hidden'}`}>
            <label
              data-tag="all"
              className={`btn block py-1 px-5 font-normal border-b border-light-blue hover--text-white hover--bg-ubc-blue ${tag === "all" ? "active" : ""}`}
            >
              <input
                type="radio"
                value="all"
                checked={tag === "all"}
                onChange={() => { onTag("all"); setOpenFilter(null); }}
                className="sr-only"
              />
              All Tags
            </label>
            {tagOptions.map(t => (
              <label
                key={t}
                data-tag={t.toLowerCase().replace(/\s+/g, '-')}
                className={`btn block py-1 px-5 font-normal border-b border-light-blue hover--text-white hover--bg-ubc-blue ${tag === t ? "active" : ""}`}
              >
                <input
                  type="radio"
                  value={t}
                  checked={tag === t}
                  onChange={() => { onTag(t); setOpenFilter(null); }}
                  className="sr-only"
                />
                {t}
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
